import 'react-tabulator/lib/styles.css'; 
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import '../../resources/css/maintenance/AccountList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactExport from "react-data-export";
import { withRouter } from 'react-router-dom';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { Row } from 'react-bootstrap';
import { queryAccountsData, removeAccount, QUERY_ACCOUNTS } from '../../actions/account/index';
import FilterSearch from '../common/FilterSearch';
import ListSettingBtn from '../common/ListSettingBtn';
import CommonListFooter from '../common/CommonListFooter';
import { updateMaxPageNumber, getTableInfoFromSession, reloadTable, groupMenuTitleFormatter, commonListFooter } from '../common/access-list';
import Loading from '../../components/common/Loading';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let deleteRow;

const GroupBtnsMenu = (props) => {
  // const cellData = props.cell._cell.row.data;
  return (
      <div className='group-buttons-menu'>
          <span className='operation-button-area'>
            <span className='btn-area'><span className='icon-btn-remove' onClick={() => deleteRow(props)}/></span>
          </span>
          <span className='more-button-area'>
            <span className='btn-area'><span className='icon-btn-more-dark'/></span>
          </span>
      </div>
  );
};

class AccountList extends Component {
  tableId = 'accountList'
  refFilterSearch = null
  refListCommonFooter = null
  // set this state for re-fresh sub component
  state = {
    refTable: null,
    isInitComplete: false,
    filterColumns: [
      { title: "Model Number", field: "modelName", visible: true },
      { title: "Serial Number", field: "SN", visible: true },
      { title: "Email", field: "email", visible: true }
    ],
    /**
     *  visibleColumnsConfig is array
     *  title is menu tile
     *  columns is all changed visible columns for table list to display
     */
    visibleColumnsConfig : {
      title: 'Visible Columns',
      columns: [
        { name:'sn', title: "Serial Number", field: "SN" },
        { name:'modelName', title: "Model Number", field: "modelName" },        
        { name:'email', title: "Email", field: "email" },
        { name:'name', title: "Name", field: "name" }
      ]
    },
    sessionKey: 'RangeHood.AccountListParams'
  }

  constructor(props) {
    super(props);

    // bind this props to function
    this.dataLoading = this.dataLoading.bind(this);
    deleteRow = this.deleteRow.bind(this);

    // this component use props
    this.ref = null;
    this.rowClickType = null;
  };

  queryAccountList = (table, selectValue, searchKeyword, allSelectValues, refFilter, quickFilters) => {
    const { idToken, queryAccountsData } = this.props;

    let reqBodyObj = {};
    if (searchKeyword) {
      if (selectValue) {
        reqBodyObj[selectValue] = searchKeyword;
      } else {
        // all
        allSelectValues.forEach((thisSelectValue) => {
          reqBodyObj[thisSelectValue] = searchKeyword;
        })
      }
    }    

    if (idToken) {
      queryAccountsData(idToken, reqBodyObj);
    }
  }

  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
   *  
   ***/
  columns = [
    { title: "SN", field: "SN" },
    { title: "Model Number", field: "modelName" },
    { title: "thingName", field: "thingName", visible:false },
    { title: "uid", field: "uid", visible:false },
    { title: "Email", field: "email" },
    { title: "Name", field: "name", visible: false },
    { title: "", field: "buttonGroup", minWidth: 180, headerSort:false, formatter: reactFormatter(<GroupBtnsMenu />),
      titleFormatter: groupMenuTitleFormatter, titleFormatterParams:{tableId : 'accountList'}}
  ];

  initList = (ref) => {
    if (ref && !this.state.isInitComplete) {
      // if not init and ref has data      
      // step1. init go to page button and change pagination button
      this.refListCommonFooter.initCommonListFooter();

      // step2. init page max label
      const table = ref.table;
      updateMaxPageNumber(table);

      // step3. init page buttons
      this.refListCommonFooter.overwritePageBtns();

      // step4. pagination init complete, save into state
      this.setState({
        isInitComplete:true,
        refTable:ref.table
      });

      // step5. if has reload table form session, reload it
      const { sessionKey } = this.state;
      const keepTableInfo = getTableInfoFromSession(sessionKey);
      if (keepTableInfo) {
        setTimeout(() => {
          reloadTable(table, keepTableInfo, this.refFilterSearch);
        }, 50);
      }
    }
  }

  dataLoading = (datas) => {
    // const { status, reloadPageNumber } = this.props;
    // if (this.ref && !this.state.isInitComplete) {
    //   this.initList(this.ref);
    // } else {
      // if no init also need change icons
      this.refListCommonFooter.overwritePageBtns();
    // }
  }

  deleteRow = (props) => {
    this.rowClickType = 'DELETE';
    const { idToken, removeAccount, accounts } = this.props;    

    let check = window.confirm("Really to remove the account?");
    if (check) {
      const row = props.cell.getRow();
      const data = row.getData();

      const reqBodyObj = {
        email: data.email,
        name: data.name,
        uid: data.uid,
        thingName: data.thingName,
        from: 'Dashboard'
      };

      // do remove
      removeAccount(idToken, reqBodyObj, accounts);
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { menuMode } = this.props;
    if (prevProps.menuMode !== menuMode) {
      // if menu chagne size(mode), need redraw table
      const { refTable } = this.state;
      if (refTable) {
        refTable.redraw(false);
      }      
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.initList(this.ref);
    }, 10);
  }

  render() {
    const paginationSize = 50;
    const options = {
      movableRows: false,
      pagination: 'local',
      paginationSize: paginationSize
    };

    const date = new Date();
    const timestamp = moment(date).format('YYYYMMDD');
    const excelFileName = 'Account List ' + timestamp + '.csv';
    const { accounts, popLoading, status } = this.props;
    const { filterColumns, refTable } = this.state;

    if (status === QUERY_ACCOUNTS) {
      return <Loading loading={true}></Loading>;
    } else {
      return (
        <div>
          <CommonListFooter tableId={this.tableId} refTable={refTable} refs={(ref) => {this.refListCommonFooter = ref;}} displayPaginationSize={paginationSize}></CommonListFooter>
          <div className='filter-bar'>
            <Row>
              <div className='area-list-title'>
                <div className='list-title'>Account</div>
              </div>
              <div className='area-filter'>
                <FilterSearch filterId='accountListFilter' refTable={refTable} refColumns={filterColumns} refs={(ref) => {this.refFilterSearch = ref;}} title='Search type' 
                  doFilterFn={ this.queryAccountList } />
              </div>
              <div className='area-table-tool-bar'>
                <ListSettingBtn tableId={this.tableId} refTable={refTable} refs={(ref) => {this.refTableToolBar = ref;}}
                  visibleColumnsConfig={this.state.visibleColumnsConfig} defaultColumns={this.columns}>
                </ListSettingBtn>
              </div>
              <div className='area-list-btns' title='Reload list'>
                <span className='area-icon-btn-excel'>
                  <ExcelFile filename={ excelFileName } element={<span className='icon-btn-export-excel'/>}>
                      <ExcelSheet data={ accounts } name="Accounts">                        
                          <ExcelColumn label="Serial Number" value="SN"/>
                          <ExcelColumn label="Model Number" value="modelName"/>
                          <ExcelColumn label="Email" value="email"/>
                      </ExcelSheet>
                  </ExcelFile>
                </span>
                <span className='area-icon-btn-reload'><span className='icon-btn-reload' onClick={() => this.reloadList()} /></span>
              </div>
            </Row>
          </div>
          <div className='custom-list-table-area'>
            <ReactTabulator
              ref={ref => {
                this.ref = ref;
                // this.initList(ref);
              }}
              columns={this.columns}
              data={accounts}
              options={options}
              data-custom-attr="test-custom-attribute"
              className="custom-list-table"
              footerElement={commonListFooter}
              dataLoading={this.dataLoading}
              renderComplete={this.changePageNumber}
            />
          </div>
          <Loading loading={popLoading} center={true}></Loading>
        </div>
      );
    }
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.accountReducers.status,
    accounts: state.accountReducers.accounts,
    popLoading: state.accountReducers.popLoading,
    errMsg: state.accountReducers.errMsg,
    menuMode: state.menuReducers.displayMode
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { queryAccountsData, removeAccount }
)(AccountList))
